// extracted by mini-css-extract-plugin
export default {"toggle":"_2tzx5","disabled":"_1EIuO","icon":"_1JREZ","activated":"_3YWV4","handle":"_24xvq"};